<div class="row">
  <div class="col-sm-1"></div>
  <div class="col-sm-10">
  </div>
  <div class="col-sm-1"></div>
</div>
<section style="overflow-x: hidden;">
  <img
  class="css-z1tvno"
  style="
  display: block;
  position: absolute;
  width: 100%;
  height: 70vh;
  object-fit: cover;
  font-size: 14px;
  "
  title="login image"
  alt="top-bg"
  src="assets/img/syarat-ketentuan.png"
/>
</section>
<section
  style="
    padding-top: 500px;
    padding-bottom: 64px;
    position: relative;
    display: block;
    overflow-x: hidden;
  "
>
  <div
    style="
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
      margin-left: auto;
      margin-right: auto;
    "
  >
    <div
      class="css-1iki9lf"
      style="
        font-size: 32px;
        line-height: 1.41;
        color: #777;
        font-weight: 800;
        text-align: center;
      "
    >
      SYARAT & KETENTUAN PENGGUNA (Customer)
    </div>
  </div>
</section>
<section style="display: block; overflow-x: hidden;">
  <div class="row" style="width: 100%; margin-left: 20px;">
   <div class="some-wrapper">
      <p>&nbsp;</p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Selamat datang di
        <strong>
          <strong style="color: #777;">www.sukandaonelink.com.</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Syarat dan ketentuan yang ditetapkan di bawah ini mengatur
        ketentuan penggunaan layanan yang ditawarkan PT Sukanda Djaya terkait penggunaan situs
        <a href="http://www.sukandaonelink.com">
          <u>www.sukandaonelink.com</u>
        </a>
        &nbsp;oleh customer. Calon customer maupun customer disarankan
        membaca syarat dan ketentuan ini dengan seksama, karena dapat
        berdampak kepada hak dan kewajiban customer di bawah hukum.
      </p>
      <p>&nbsp;</p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Syarat dan ketentuan ini merupakan bentuk kesepakatan yang
        dituangkan dalam sebuah perjanjian yang sah antara customer
        dengan Sukanda Onelink. Dengan mendaftar di situs
        <a href="http://www.sukandaonelink.com">
          <u>www.sukandaonelink.com</u>
        </a>
        &nbsp;sebagai customer, maka customer dianggap telah membaca,
        mengerti, memahami dan menyutujui semua isi dalam syarat dan
        ketentuan ini. Jika customer tidak menyetujui salah satu,
        sebagian, atau seluruh isi syarat dan ketentuan ini, maka
        customer tidak diperkenankan menggunakan layanan di
        <a href="http://www.sukandaonelink.com">
          <u>www.sukandaonelink.com</u>
        </a>
        .
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>A. DEFINISI</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style="margin-left: 20px; margin-right: 80px;">
        <li>
          <strong>
            <strong>Akun </strong>
          </strong>
          adalah akun di Situs yang dimiliki oleh Pengguna sebagai
          Customer setelah terdaftar di Situs.
        </li>
        <li>
          <strong>
            <strong>Barang</strong>
          </strong>
          adalah benda yang berwujud / memiliki fisik Barang yang
          dapat diantar / memenuhi kriteria pengiriman oleh perusahaan
          jasa pengiriman Barang yang diperdagangkan melalui Situs.
        </li>
        <li>
          <strong>
            <strong>Customer Service</strong>
          </strong>
          adalah fasilitator yang disediakan oleh Sukanda Onelink untuk
          membantu penyelesaian permasalahan terkait penggunaan Situs.
        </li>
        <li>
          <strong>
            <strong>Feed</strong>
          </strong>
          adalah fitur pada Situs yang menampilkan&nbsp;katalog dari
          produk.
        </li>
        <li>
          <strong>
            <strong>Customer </strong>
          </strong>
          adalah pengguna terdaftar yang melakukan permintaan atas
          barang yang dijual oleh PT Sukanda Djaya di situs Sukanda Onelink. Customer merupakan
          pelanggan dari PT Sukanda Djaya.
        </li>
        <li>
          <strong>
            <strong>Pengguna</strong>
          </strong>
          adalah customer PT Sukanda Djaya.
        </li>
        <li>
          <strong>
            <strong>PT Sukanda Djaya</strong>
          </strong>
          adalah perusahaan distribusi berbagai jenis makanan dan minuman, yang menyediakan sukanda Onelink untuk memudahkan customer dalam berbelanja.
          <strong>
            <strong>Sukanda Onelink</strong>
          </strong>
          &nbsp;adalah tempat berbelanja elektronik (
          <em>
            <em>platform</em>
          </em>
          ) berupa situs web berbasis internet yang memfasilitasi
          perdagangan Barang antara PT Sukanda Djaya dan Customer melalui Situs.
          Untuk keperluan Syarat &amp; Ketentuan ini, yang dimaksud
          dengan pihak Sukanda Onelink adalah PT Sukanda Djaya.
        </li>
        <li>
          <strong>
            <strong>Rekening Resmi</strong>
          </strong>
          adalah rekening bersama yang dipilih dan disepakati oleh
          Sukanda Onelink dan Pengguna untuk proses transaksi jual beli di
          Situs.
        </li>
        <li>
          <strong>
            <strong>Situs </strong>
          </strong>
          adalah situs web Sukanda Onelink, yaitu
          <a href="http://www.sukandaonelink.com">www.sukandaonelink.com</a>
        </li>
        <li>
          <strong>
            <strong>Syarat &amp; ketentuan </strong>
          </strong>
          <u></u>adalah perjanjian antara Pengguna dan Sukanda Onelink yang
          berisikan
          <u>
            ketentuan-ketentuan yang mengatur hak, kewajiban, tanggung
            jawab pengguna dan Sukanda Onelink, serta tata cara penggunaan
            sistem layanan Sukanda Onelink.
          </u>
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>B. KETENTUAN UMUM</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style="margin-left: 20px; margin-right: 80px;">
        <li>
          Penggunaan Situs ini bebas biaya. Untuk dapat menggunakan
          layanan Situs, diperlukan koneksi kepada jaringan internet
          dan segala biaya yang timbul atas koneksi perangkat
          Customerdengan jaringan internet sepenuhnya ditanggung oleh
          Customer.
        </li>
        <li>
          Situs dapat digunakan oleh Customer dengan terlebih dahulu
          melakukan pendaftaran yang disertai pemberian informasi data
          pribadi Customersebagaimana diminta dalam Situs (&ldquo;Data
          Pribadi&rdquo;). Informasi terkait Data Pribadi yang
          diberikan hanya akan digunakan untuk pemberian layanan dan
          peruntukan lain&nbsp;yang dimuat dalam Kebijakan Privasi.
          Informasi tambahan wajib diberikan oleh Customer untuk dapat
          mempergunakan layanan tertentu dalam. Ketentuan lebih lanjut
          terkait dengan Data Pribadi diatur dalam Kebijakan Privasi
          sebagai bagian dari Syarat &amp;Ketentuan Penggunaan ini.
        </li>
        <li>
          Situs tidak membuat pernyataan atau memberikan jaminan
          apapun, baik tersurat maupun tersirat, mengenai kelengkapan,
          akurasi, keandalan, kesesuaian, kepuasan, keamanan,
          kecepatan, ketersediaan fitur, informasi, produk, layanan,
          gambar, estimasi biaya atau grafis terkait yang terdapat
          dalam Situs untuk setiap tujuan apapun juga. Gambar, grafis
          dan foto yang ada dalam Situs mungkin tunduk terhadap
          suatu hak kekayaan intelektual yang dimiliki oleh pihak
          ketiga dan Sukanda Onelink tidak menjamin dalam bentuk apapun
          juga atas hak tersebut.
        </li>
        <li>
          Dalam penggunaan Situs ini, Customer dapat memiliki pilihan
          dan kesempatan untuk tersambung, terakses, atau terhubung
          dengan&nbsp;
          <em>
            <em>Application Programming Interface</em>
          </em>
          (&ldquo;API&rdquo;) dan&nbsp;
          <em>
            <em>Uniform&nbsp;Resource&nbsp;Locator</em>
          </em>
          &nbsp;(&ldquo;URL&rdquo;) pihak ketiga dan Mitra Kami
          yang tidak berada di bawah kendali Situs. Sukanda Onelink tidak
          memiliki kontrol atas sifat, isi dan ketersediaan dari API
          dan URL tersebut. Ketersediaan setiap API dan URL
          dalam Situs ini tidak menyiratkan bahwa Sukanda Onelink
          merekomendasikan &nbsp;API&nbsp;dan URL tersebut atau
          mendukung dan menyetujui pandangan yang diungkapkan
          dan dinyatakan dalam API dan URL pihak ketiga
          dan afiliasi Sukanda Onelink dan Mitra Kami.
        </li>
        <li>
          Sukanda Onelink memiliki kebijakan sendiri dan menyeluruh untuk
          menerima atau menunda atau menolak permintaan anda atas
          layanan dalam Situs
          <em>
            <em>.</em>
          </em>
        </li>
        <li>
          Dalam penyediaan Layanan ini, Kami dapat bekerja samadengan
          Mitra Kami. Semua risiko dan kerugian yang mungkin
          ditimbulkan oleh kelalaian Mitra Kami (termasuk namun tidak
          terbatas pada penyelesaian transaksi) adalah di luar
          wewenang dan tanggung jawab Sukanda Onelink.
        </li>
      </ol>
      <p>
        <strong>
          <strong>C. PENDAFTARAN AKUN, DAN KEAMANAN</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style="margin-left: 20px; margin-right: 80px;">
        <li>
          Customer dengan ini menyatakan bahwa Customer adalah orang
          yang cakap dan mampu untuk mengikatkan dirinya dalam sebuah
          perjanjian yang sah menurut hukum.
        </li>
        <li>
          Customer yang telah mendaftar berhak bertindak sebagai:
          <ul>
            <li>
              &ndash; Customer untuk keperluan belanja pribadi
            </li>
            <li>
              &ndash; Customer untuk keperluan belanja perusahaan
            </li>
          </ul>
        </li>
        <li>
          Customer dilarang untuk menciptakan dan menggunakan
          perangkat,&nbsp;
          <em>
            <em>software,&nbsp;</em>
          </em>
          fitur&nbsp;dan alat lainnya yang bertujuan untuk
          melakukan manipulasi pada sistem Situs, termasuk namun tidak
          terbatas pada:&nbsp;(i) kegiatan perambanan (
          <em>
            <em>crawling/scraping</em>
          </em>
          ); (ii) kegiatan otomatisasi dalam transaksi, jual beli,
          dsb; dan (iii) aktivitas lain yang secara wajar dapat
          dinilai sebagai tindakan manipulasi sistem.
        </li>
        <li>
          Sukanda Onelink memiliki kewenangan untuk melakukan proses
          moderasi/menutup akun Customer, jika diketahui atau diduga
          adanya penyalahgunaan perangkat,
          <em>
            <em>software</em>
          </em>
          , &nbsp;fitur lainnya oleh Customer yang bertujuan
          memanipulasi data pada system Situs.
        </li>
        <li>
          Customer bertanggung jawab secara pribadi untuk menjaga
          kerahasiaan akun dan password untuk semua aktivitas yang
          terjadi dalam akun Customer.
        </li>
        <li>
          Sukanda Onelink tidak akan meminta username,&nbsp;password maupun
          kode SMS verifikasi&nbsp;atau kode OTP milik&nbsp;akun
          Customer untuk alasan apapun, oleh karena itu Sukanda Onelink
          menghimbau Customer agar tidak memberikan data tersebut
          maupun data penting lainnya kepada pihak&nbsp;yang
          mengatasnamakan Sukanda Onelink atau pihak lain yang tidak dapat
          dijamin keamanannya. Dalam hal terjadi pengungkapan
          username,&nbsp;password maupun kode SMS verifikasi&nbsp;atau
          kode verifikasi (OTP) atas akun milik Customer dalam Situs
          dengan cara apapun yang terjadi bukan atas kesalahan
          Sukanda Onelink dan mengakibatkan penggunaan yang tidak sah
          dan tanpa kewenangan atas akun Customer, permintaan
          informasi maupun aktivitas yang dilakukan dalam Sukanda Onelink
          akan tetap dianggap sebagai permintaan maupun aktivitas yang
          sah kecuali Customer memberitahukan kepada Sukanda Onelink tentang
          hal tersebut sebelumnya.
        </li>
        <li>
          Customer setuju untuk memastikan bahwa Customer keluar dari
          akun di akhir setiap sesi dan memberitahu Sukanda Onelink jika
          ada penggunaan tanpa izin atas sandi atau akun Customer.
        </li>
        <li>
          Customer dengan ini menyatakan bahwa Sukanda Onelink tidak
          bertanggung jawab atas kerugian ataupun kendala yang timbul
          atas penyalahgunaan akun Customer yang diakibatkan oleh
          kelalaian Customer, termasuk namun tidak terbatas pada
          meminjamkan atau memberikan akses akun kepada pihak lain,
          mengakses link atau tautan yang diberikan oleh pihak lain,
          memberikan atau memperlihatkan kode verifikasi (OTP),
          password atau email kepada pihak lain, maupun kelalaian
          Customer lainnya yang mengakibatkan kerugian ataupun kendala
          pada akun Customer.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>D. TRANSAKSI CUSTOMER</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style="margin-left: 20px; margin-right: 80px;">
        <li>
          Customer wajib bertransaksi melalui prosedur transaksi yang
          telah ditetapkan oleh Sukanda Onelink.
        </li>
        <li>
          Saat melakukan Customer Barang, Customer menyetujui bahwa:
          <ul>
            <li>
              - Customer bertanggung jawab untuk membaca, memahami, dan
              menyetujui informasi/deskripsi keseluruhan Barang
              (termasuk didalamnya namun tidak terbatas pada warna,
              kualitas, fungsi, dan lainnya) sebelum membuat tawaran
              atau komitmen untuk membeli.
            </li>
            <li>
              - Customer mengakui bahwa warna sebenarnya dari produk
              sebagaimana terlihat di Situs tergantung pada monitor
              komputeratau layer ponsel Sukanda Onelink telah melakukan
              upaya terbaik untuk memastikan warna dalam foto-foto
              yang ditampilkan di Situs muncul seakurat mungkin,
              tetapi tidak dapat menjamin bahwa penampilan warna pada
              Situs akan akurat.
            </li>
            <li>
              - Customer masuk ke dalam kontrak yang mengikat secara
              hukum dengan Penjual untuk membeli Barang ketika
              Customer&nbsp;membeli suatu barang di Situs.
            </li>
            <li>
              - Sukanda Onelink tidak mengalihkan kepemilikan secara hukum
              atas barang-barang dari Penjual kepada Customer. Untuk
              menghindari keragu-raguan, hubungan hukum dalam
              transaksi jual beli di Situs merupakan hubungan antara
              Penjual dan Customer.
            </li>
          </ul>
        </li>
        <li>
          Customer memahami dan menyetujui bahwa ketersediaan stok
          Barang merupakan tanggung jawab Penjual yang menawarkan
          Barang tersebut. Terkait ketersediaan stok Barang dapat
          berubah sewaktu-waktu, sehingga dalam keadaan stok Barang
          kosong, maka Penjual akan menolak order, dan pembayaran atas
          barang yang bersangkutan dikembalikan kepada Customer.
        </li>
        <li>
          Customermemahami sepenuhnya dan menyetujui bahwa segala
          transaksi yang dilakukan antar Customer dan Penjual selain
          melalui Situs dan Rekening Resmi Sukanda Onelink dan tanpa
          sepengetahuan Sukanda Onelink (melalui fasilitas/jaringan
          pribadi, pengiriman pesan, pengaturan transaksi khusus
          diluar Situs atau upaya lainnya) adalah merupakan tanggung
          jawab pribadi dari Customer.
        </li>
        <li>
          Sukanda Onelink memiliki kewenangan sepenuhnya untuk menolak
          pembayaran tanpa pemberitahuan terlebih dahulu.
        </li>
        <li>
          (i) Pembayaran oleh Customer wajib dilakukan segera setelah
          Customer memilih metode pembayaran untuk transaksi tersebut.
          Jika dalam batas waktu tersebut pembayaran atau konfirmasi
          pembayaran belum dilakukan oleh Customer, Sukanda Onelink memiliki
          kewenangan untuk membatalkan transaksi dimaksud.
          Customertidak berhak mengajukan klaim atau tuntutan atas
          pembatalan transaksi tersebut.
          <br />
          <br />
          (ii) Pembayaran oleh Customer untuk keperluan belanja
          perusahaan wajib dilakukan sesuai dengan TOP (Terms of
          Payment) yang disepakati dengan
          Sukanda Onelink. .
        </li>
      </ol>
      <ol start="7" style="margin-left: 20px; margin-right: 80px;">
        <li>
          Customer untuk keperluan perusahaan wajib melakukan
          konfirmasi pemesanan Barang dengan meng-upload soft copy
          dokumen
          <em>
            <em>Purchase Order </em>
          </em>
          (PO) di Situs paling lambat 3 (tiga) hari kerja setelah
          melakukan perintah pemesanan (
          <em>
            <em>Booking Order</em>
          </em>
          )di Situs. Jika dalam batas waktu tersebut konfirmasi
          Customer belum dilakukan oleh Customer untuk keperluan
          perusahaan, Sukanda Onelink memiliki kewenangan untuk membatalkan
          transaksi dimaksud. Customer untuk keperluan perusahaan dan
          Penjual tidak berhak mengajukan klaim atau tuntutan kepada
          Sukanda Onelink atas pembatalan transaksi tersebut.
        </li>
        <li>
          Customer wajib melakukan konfirmasi penerimaan Barang,
          setelah menerima kiriman Barang yang dibeli. Sukanda Onelink
          memberikan batas waktu 2 (dua) hari kalender setelah
          pengiriman berstatus "terkirim" pada sistem Situs, untuk
          Customer melakukan konfirmasi penerimaan Barang. Jika dalam
          batas waktu tersebut tidak ada konfirmasi atau klaim dari
          pihak Customer, maka dengan demikian Customer menyatakan
          menyetujui dilakukannya konfirmasi penerimaan Barang secara
          otomatis oleh sistem Sukanda Onelink.
        </li>
        <li>
          Setelah adanya konfirmasi penerimaan Barang atau konfirmasi
          penerimaan Barang otomatis, maka dana pihak Customer yang
          dikirimkan ke Rekening resmi Sukanda Onelink akan di lanjut
          kirimkan ke pihak Penjual (transaksi dianggap selesai).
        </li>
        <li>
          Customer memahami dan menyetujui bahwa setiap masalah
          pengiriman Barang yang disebabkan keterlambatan pembayaran
          adalah merupakan tanggung jawab dari Customer.
        </li>
        <li>
          Customer memahami dan menyetujui bahwa masalah keterlambatan
          proses pembayaran dan biaya tambahan yang disebabkan oleh
          perbedaan bank yang Customer pergunakan dengan bank Rekening
          resmi Sukanda Onelink adalah tanggung jawab Customer.
        </li>
        <li>
          <strong>
            <strong>
              Pengembalian dana dari Sukanda Onelink kepada Customer hanya
              dapat dilakukan jika dalam keadaan-keadaan tertentu
              berikut ini:
            </strong>
          </strong>
          <ul>
            <li>
              <strong>
                <strong>
                  - Masalah pengiriman Barang telah teridentifikasi
                  secara jelas dari Penjual yang mengakibatkan pesanan
                  Barang tidak sampai,
                </strong>
              </strong>
            </li>
            <li>
              <strong>
                <strong>
                  - Penyelesaian permasalahan melalui CS Sukanda Onelink
                  berupa keputusan untuk pengembalian dana kepada
                  Customer atau hasil keputusan dari pihak Sukanda Onelink.
                </strong>
              </strong>
            </li>
          </ul>
        </li>
        <li>
          <strong>
            <strong>
              Apabila terjadi proses pengembalian dana, maka
              pengembalian akan dilakukan melalui transfer ke rekening
              milik Customer sesuai dengan jumlah keseluruhan dana yang
              dikembalikan.
            </strong>
          </strong>
        </li>
        <li>
          Sukanda Onelink berwenang mengambil keputusan atas
          permasalahan-permasalahan transaksi yang belum terselesaikan
          akibat tidak adanya kesepakatan penyelesaian, baik antara
          Penjual dan Customer, dengan melihat bukti-bukti yang ada.
          Keputusan Sukanda Onelink adalah keputusan akhir yang tidak dapat
          diganggu gugat dan mengikat pihak Penjual dan Customer untuk
          mematuhinya.
        </li>
        <li>
          Sukanda Onelink memiliki kewenangan melakukan perubahan status
          pemesanan menjadi "terkirim" apabila tidak ada pembaharuan
          status pengiriman dari kurir setelah 25 hari sejak resi
          diinput oleh Penjual dan tidak ada konfirmasi lebih lanjut
          dari pihak Customer perihal barang pesanan. Kemudian dalam
          jangka waktu 5 hari sejak perubahan status tersebut diatas,
          Sukanda Onelink memberikan kesempatan kepada pihak Customer untuk
          melakukan (i) konfirmasi penerimaan barang atau (ii)
          Komplain. Jika dalam jangka waktu 5 hari tersebut tidak ada
          konfirmasi penerimaan barang atau komplain apapun dari
          Customer, maka Sukanda Onelink memiliki kewenangan untuk
          menyelesaikan transaksi dan meneruskan dana kepada Penjual
          bersangkutan yang dianggap telah melakukan kewajibannya
          mengirimkan barang dan menginformasikan nomor resi
          pengiriman. Penyesuaian status pemesanan ini hanya akan
          dilakukan apabila alamat tujuan pengiriman yang tertera pada
          invoice pemesanan dan resi kurir telah sesuai.
        </li>
        <li>
          Customer memahami sepenuhnya dan menyetujui bahwa invoice
          yang diterbitkan oleh Sukanda Onelink adalah atas nama Penjual.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>E. HARGA</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style="margin-left: 20px; margin-right: 80px;">
        <li>
          Harga Barang yang terdapat dalam Situs adalah harga yang
          ditetapkan oleh Penjual.
        </li>
        <li>
          Customer memahami dan menyetujui bahwa kesalahan keterangan
          harga dan informasi lainnya yang disebabkan tidak
          terbaharuinya halaman Situs dikarenakan browser/ISP yang
          dipakai Customer adalah tanggung jawab Customer.
        </li>
        <li>
          Customer memahami dan menyetujui bahwa setiap masalah
          dan perselisihan yang terjadi akibat ketidaksepahaman
          antara Penjual dan Customer tentang harga bukanlah merupakan
          tanggung jawab Sukanda Onelink.
        </li>
        <li>
          Dengan melakukan pemesanan melalui Sukanda Onelink, Customer
          menyetujui untuk membayar total biaya yang harus dibayarkan
          sebagaimana tertera dalam halaman pembayaran, yang terdiri
          dari harga barang, ongkos kirim, dan biaya-biaya lain yang
          mungkin timbul dan akan diuraikan secara tegas dalam halaman
          pembayaran. Customer setuju untuk melakukan pembayaran
          melalui metode pembayaran yang telah dipilih sebelumnya oleh
          Customer. &nbsp;&nbsp;
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>F</strong>
        </strong>
        <strong>
          <strong>. KONTEN</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style="margin-left: 20px; margin-right: 80px;">
        <li>
          Dalam menggunakan setiap fitur dan layanan Sukanda Onelink,
          Customer dilarang untuk mengunggah atau mempergunakan
          kata-kata, komentar, gambar, atau konten apapun yang
          mengandung unsur SARA, diskriminasi, merendahkan atau
          menyudutkan orang lain, vulgar, bersifat ancaman, beriklan
          atau melakukan promosi ke situs selain Situs, atau hal-hal
          lain yang dapat dianggap tidak sesuai dengan nilai dan norma
          sosial, pornografi, pelanggaran hak kekayaan intelektual,
          ujaran kebencian, menganjurkan kekerasan, terorisme, akses
          terhadap narkoba, zat adiktif, dan psikotropika, perjudian,
          dan hal-hal lain yang dilarang oleh hukum dan peraturan yang
          berlaku maupun berdasarkan kebijakan yang ditentukan sendiri
          oleh Sukanda Onelink. Sukanda Onelink berhak melakukan tindakan yang
          diperlukan atas pelanggaran ketentuan ini, antara lain
          penghapusan konten, pemblokiran akun, dan lain-lain.
        </li>
        <li>
          Customer dilarang mempergunakan foto/gambar Barang yang
          memiliki watermark yang menandakan hak kepemilikan orang
          lain.
        </li>
        <li>
          Customer dengan ini memahami dan menyetujui bahwa Customer
          bertanggung jawab secara penuh atas foto/gambar yang di
          unggah oleh Customer. Penyalahgunaan foto/gambar yang di
          unggah oleh Customer adalah tanggung jawab Customer secara
          pribadi.
        </li>
        <li>
          Ketika Customer mengunggah ke Situs dengan konten atau
          posting konten, Customer memberikan Sukanda Onelink hak
          non-eksklusif, di seluruh dunia, secara terus-menerus, tidak
          dapat dibatalkan, bebas royalti, dapat disublisensikan (
          melalui beberapa tingkatan ), hak untuk melaksanakan setiap
          dan semua hak cipta, publisitas , merek dagang , hak basis
          data dan hak kekayaan intelektual yang Customer miliki dalam
          konten, di media manapun yang dikenal sekarang atau di masa
          depan. Selanjutnya, untuk sepenuhnya diizinkan oleh hukum
          yang berlaku , Customer mengesampingkan hak moral dan
          berjanji untuk tidak menuntut hak-hak tersebut terhadap
          Sukanda Onelink.
        </li>
        <li>
          Customer menjamin bahwa tidak melanggar hak kekayaan
          intelektual dalam mengunggah konten Customer kedalam Situs.
          Setiap Customerdengan ini bertanggung jawab secara pribadi
          atas pelanggaran hak kekayaan intelektual dalam mengunggah
          konten di Situs.
        </li>
        <li>
          Meskipun Sukanda Onelink mencoba untuk menawarkan informasi yang
          dapat diandalkan, kami tidak bisa menjanjikan bahwa katalog
          akan selalu akurat dan terbarui, dan Customer setuju bahwa
          Customer tidak akan meminta Sukanda Onelink bertanggung jawab atas
          ketimpangan dalam katalog. Katalog mungkin termasuk hak
          cipta, merek dagang atau hak milik lainnya.
        </li>
        <li>
          Konten atau materi yang akan ditampilkan atau ditayangkan
          pada Situs/Aplikasi&nbsp;Sukanda Onelink
          melalui&nbsp;Feed&nbsp;akan tunduk pada Ketentuan Situs,
          peraturan hukum, serta etika pariwara yang berlaku.
        </li>
        <li>
          Customer atau pihak lainnya yang menggunakan fitur
          Feed&nbsp;bertanggungjawab&nbsp;penuh&nbsp;terhadap konten
          atau materi yang&nbsp;diunggahmelalui&nbsp;fitur Feed.
        </li>
        <li>
          Sukanda Onelink berhak untuk sewaktu-waktu menurunkan konten atau
          materi yang terdapat pada&nbsp;Feed&nbsp;yang dianggap
          melanggar Syarat dan Ketentuan Situs, peraturan hukum yang
          berlaku, serta etika pariwara yang berlaku.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>G</strong>
        </strong>
        <strong>
          <strong>. PROMO</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style="margin-left: 20px; margin-right: 80px;">
        <li>
          Sukanda Onelink sewaktu-waktu dapat mengadakan kegiatan promosi
          (selanjutnya disebut sebagai &ldquo;Promo&rdquo;) dengan
          Syarat dan Ketentuan yang mungkin berbeda pada masing-masing
          kegiatan Promo. Customer dihimbau untuk membaca dengan
          seksama Syarat dan Ketentuan Promo tersebut.
        </li>
        <li>
          Sukanda Onelink berhak, tanpa pemberitahuan sebelumnya, melakukan
          tindakan-tindakan yang diperlukan termasuk namun tidak
          terbatas pada menarik subsidi atau cashback, membatalkan
          benefit, pencabutan Promo, membatalkan transaksi, menahan
          dana, serta hal-hal lainnya jika ditemukan adanya
          manipulasi, penggunaan resi yang tidak valid pada mayoritas
          transaksi, pelanggaran maupun pemanfaatan Promo untuk
          keuntungan pribadi Customer, maupun indikasi kecurangan atau
          pelanggaran pelanggaran Syarat dan Ketentuan Sukanda Onelink dan
          ketentuan hukum yang berlaku di wilayah negara Indonesia.
        </li>
        <li>
          Dalam hal diadakannya Promo Gratis/Potongan Ongkos Kirim:
          <br />- Jika terdapat selisih antara berat Barang pada
          deskripsi produk dengan berat Barang yang dikirimkan oleh
          Penjual melalui jasa kurir/logistik, maka subsidi ongkos
          kirim yang diberikan akan merujuk kepada berat
          Barang&nbsp;pada data pihak kurir/logistik;
          <br />
          <br />- Jika (i) Penjual menolak pesanan Customer, (ii)
          transaksi dibatalkan otomatis oleh sistem Situs, dan
          (iii) transaksi dibatalkan berdasarkan keputusan di Pusat
          Resolusi, maka dana yang dikembalikan kepada Customer adalah
          senilai dana pembayaran transaksi yang dilakukan oleh
          Customer dan tidak termasuk subsidi ongkos kirim.
        </li>
        <li>
          Setiap Promo Situs tidak berlaku untuk untuk penggunaan resi
          yang diinput lebih dari 1 (satu) kali, jika ditemukan
          penginputan resi sebanyak 2 (dua) kali, manfaat promo hanya
          akan diberikan pada transaksi yang dibentuk oleh Customer
          pertama. Benefit promo tidak dapat diteruskan pada transaksi
          dropshipper (Customer kedua).
        </li>
        <li>
          Customer hanya boleh menggunakan 1 (satu) akun Sukanda Onelink
          untuk mengikuti setiap promo Sukanda Onelink. Jika ditemukan
          pembuatan lebih dari 1 (satu) akun oleh 1 (satu) Customer
          yang sama dan nomor handphone yang sama dan alamat
          yang sama dan ID pelanggan yang sama dan identitas
          pembayaran yang sama dan riwayat transaksi yang sama,
          maka Customer tidak berhak mendapatkan manfaat dari promo
          Sukanda Onelink.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>H</strong>
        </strong>
        <strong>
          <strong>. PENGIRIMAN BARANG</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style="margin-left: 20px; margin-right: 80px;">
        <li>
          Pengiriman Barang dalam Situs wajib menggunakan jasa
          pengiriman yang disediakan di dalam Situs.
        </li>
        <li>
          Setiap syarat dan ketentuan berkenaan dengan proses
          pengiriman Barang adalah wewenang sepenuhnya penyedia jasa
          layanan pengiriman Barang dan bukan merupakan tanggung jawab
          Sukanda Onelink.
        </li>
        <li>
          Customer memahami dan menyetujui bahwa setiap permasalahan
          yang terjadi pada saat proses pengiriman Barang oleh
          penyedia jasa layanan pengiriman Barang adalah merupakan
          tanggung jawab penyedia jasa layanan pengiriman.
        </li>
        <li>
          Dalam hal diperlukan untuk dilakukan proses pengembalian
          barang, maka Customerdiwajibkan untuk melakukan pengiriman
          barang langsung ke masing-masing Customer maupun Penjual.
          Sukanda Onelink tidak menerima pengembalian atau pengiriman
          barang atas transaksi yang dilakukan oleh Customer&nbsp;dalam
          kondisi apapun.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>I</strong>
        </strong>
        <strong>
          <strong>. CUSTOMER SERVICE</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style="margin-left: 20px; margin-right: 80px;">
        <li>
          Apabila terdapat permasalahan transaksi antara Customer dan
          Penjual, para pihak dapat menyampaikan permasalahan tersebut
          ke Customer Service melalui alamat email :
          cs@www.sukandaonelink.com
        </li>
        <li>
          Customer Service adalah fasilitator yang disediakan oleh
          Sukanda Onelink untuk membantu penyelesaian masalah transaksi
          antara Customer dan Penjual.
        </li>
        <li>
          Ketika Customer mengirimkan laporan permasalahan ke Customer
          Service, maka sistem akan secara otomatis menahan dana
          pembayaran barang ke Penjual sampai dengan permasalahan yang
          dilaporkan ke Customer Service selesai.
        </li>
        <li>
          Dalam menggunakan fitur ini, Customer dan Penjual diharapkan
          memberikan bukti-bukti transaksi jual beli berupa foto
          barang, nota Customer, slip resi pengiriman dan bukti-bukti
          penunjang lainnya yang dapat menjadi dasar pembenar atas
          setiap argumen yang dikeluarkan oleh masing-masing pihak.
        </li>
        <li>
          Penyelesaian permasalahan melalui Customer Service dapat
          berupa solusi yang dihasilkan berdasarkan kesepakatan
          bersama antara Customer dan Penjual.
        </li>
        <li>
          Para pihak mengakui bahwa Customer Service senantiasa
          melakukan upaya terbaik untuk membantu penyelesaian
          permasalahan para pihak. Para pihak melepaskan Sukanda Onelink
          dari segala kerugian, biaya, klaim, tuntutan yang timbul
          atau mungkin timbul dari penyelesaian perselisihan antara
          Customer dan Penjual.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>J</strong>
        </strong>
        <strong>
          <strong>. KETENTUAN LAIN</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style="margin-left: 20px; margin-right: 80px;">
        <li>
          Apabila Customer mempergunakan fitur-fitur yang tersedia
          dalam Situs maka Customer dengan ini menyatakan memahami dan
          menyetujui segala syarat dan ketentuan yang diatur khusus
          sehubungan dengan&nbsp;fitur-fitur tersebut di bawah ini.
        </li>
        <li>
          Segala hal yang belum dan tidak diatur dalam syarat dan
          ketentuan khusus dalam fitur tersebut maka akan sepenuhnya
          merujuk pada syarat dan ketentuan ini.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>K</strong>
        </strong>
        <strong>
          <strong>
            . PENOLAKAN JAMINAN DAN BATASAN TANGGUNG JAWAB
          </strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Sukanda Onelink adalah portal web dengan model Business to Business
        dan Business to Customer Marketplace, yang menyediakan layanan
        kepada Pengguna untuk dapat menjadi Penjual maupun Customer di
        website Sukanda Onelink. Dengan demikian transaksi yang terjadi
        adalah transaksi antar Pengguna, sehingga Pengguna memahami
        bahwa batasan tanggung jawab Sukanda Onelink secara proporsional
        adalah sebagai penyedia jasa portal web
      </p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Sukanda Onelink selalu berupaya untuk menjaga Layanan Sukanda Onelink
        aman, nyaman, dan berfungsi dengan baik, tapi kami tidak dapat
        menjamin operasi terus-menerus atau akses ke Layanan kami
        dapat selalu sempurna. Informasi dan data dalam Situs memiliki
        kemungkinan tidak terjadi secara real time.
      </p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Customer setuju bahwa Customer memanfaatkan Layanan Sukanda Onelink
        atas risiko Customer sendiri, dan Layanan Sukanda Onelink diberikan
        kepada Customer pada "SEBAGAIMANA ADANYA" dan "SEBAGAIMANA
        TERSEDIA".
      </p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Sejauh diizinkan oleh hukum yang berlaku, Sukanda Onelink (termasuk
        Induk Perusahaan, direktur, komisaris) adalah
        tidak bertanggung jawab, dan Customer setuju untuk tidak
        menuntut Sukanda Onelink bertanggung jawab, atas segala kerusakan
        atau kerugian (termasuk namun tidak terbatas pada hilangnya
        uang, reputasi, keuntungan, atau kerugian tak berwujud
        lainnya) yang diakibatkan secara langsung atau tidak langsung
        dari :
      </p>
      <ul style="margin-left: 20px; margin-right: 80px;">
        <li>
          - Penggunaan atau ketidakmampuan Customer dalam menggunakan
          Situs.
        </li>
        <li>
          - Harga, Pengiriman atau petunjuk lain yang tersedia dalam
          layanan Situs.
        </li>
        <li>- Keterlambatan atau gangguan dalam Situs.</li>
        <li>
          - Kelalaian dan kerugian yang ditimbulkan oleh masing-masing
          Pengguna.
        </li>
        <li>- Kualitas Barang.</li>
        <li>- Pengiriman Barang.</li>
        <li>- Pelanggaran Hak atas Kekayaan Intelektual.</li>
        <li>- Perselisihan antar pengguna.</li>
        <li>- Pencemaran nama baik pihak lain.</li>
        <li>
          - Setiap penyalahgunaan Barang yang sudah dibeli pihak
          Customer.
        </li>
        <li>
          - Kerugian akibat pembayaran tidak resmi kepada pihak lain
          selain ke Rekening Resmi Sukanda Onelink, yang dengan cara apa
          pun mengatas-namakan Sukanda Onelink ataupun kelalaian penulisan
          rekening dan informasi lainnya dan kelalaian pihak
          bank.
        </li>
        <li>
          - Pengiriman untuk perbaikan Barang yang bergaransi resmi
          dari pihak produsen. Customer dapat membawa Barang langsung
          kepada pusat layanan servis terdekat dengan kartu garansi
          dan faktur Customer.
        </li>
        <li>
          - Virus atau perangkat lunak berbahaya lainnya (
          <em>
            <em>bot, script, automation tool</em>
          </em>
          ,&nbsp;
          <em>
            <em>hacking tool</em>
          </em>
          ) yang diperoleh dengan mengakses, atau menghubungkan ke
          Situs.
        </li>
        <li>
          - Gangguan, bug, kesalahan atau ketidakakuratan apapun dalam
          Situs.
        </li>
        <li>
          - Kerusakan pada perangkat keras Anda dari penggunaan Situs.
        </li>
        <li>
          - Isi, tindakan, atau tidak adanya tindakan dari pihak
          ketiga, termasuk terkait dengan Produk yang ada dalam Situs
          yang diduga palsu.
        </li>
        <li>
          - Tindak penegakan yang diambil sehubungan dengan akun
          Pengguna.
        </li>
        <li>
          - Adanya tindakan peretasan yang dilakukan oleh pihak ketiga
          kepada akun Customer.
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>L</strong>
        </strong>
        <strong>
          <strong>. PELEPASAN</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Jika Anda memiliki perselisihan dengan satu atau lebih
        pengguna, Anda melepaskan PT Sukanda Djaya (termasuk Induk
        Perusahaan, Direktur, Komisaris) dari klaim dan
        tuntutan atas kerusakan dan kerugian (aktual dan tersirat)
        dari setiap jenis dan sifatnya , yang dikenal dan tidak
        dikenal, yang timbul dari atau dengan cara apapun berhubungan
        dengan sengketa tersebut,&nbsp;termasuk namun tidak terbatas
        pada kerugian yang timbul dari Customer Barang yang telah
        dilarang berdasarkan Syarat &amp; Ketentuan ini.&nbsp;Dengan
        demikian,&nbsp;maka Pengguna dengan sengaja melepaskan segala
        perlindungan hukum (yang terdapat dalam undang-undang atau
        peraturan hukum yang lain) yang akan membatasi cakupan
        ketentuan pelepasan ini.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>M</strong>
        </strong>
        <strong>
          <strong>. GANTI RUGI</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Customer akan melepaskan Sukanda Onelink dari tuntutan ganti rugi
        dan menjaga PT Sukanda Djaya (termasuk Induk Perusahaan, direktur,
        komisaris) dari setiap klaim atau tuntutan,
        termasuk biaya hukum yang wajar, yang dilakukan oleh pihak
        ketiga yang timbul dalam hal Customer melanggar Perjanjian ini,
        penggunaan layanan Sukanda Onelink yang tidak semestinya dan
        pelanggaran Customer&nbsp;terhadap hukum atau hak-hak pihak
        ketiga.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>N</strong>
        </strong>
        <strong>
          <strong>. PILIHAN HUKUM</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Syarat &amp; Ketentuan ini diatur oleh dan ditafsirkan sesuai
        dengan hukum Republik Indonesia, tanpa memperhatikan
        pertentangan aturan hukum. Customer setuju bahwa tindakan hukum
        apapun atau sengketa yang mungkin timbul dari, berhubungan
        dengan, atau berada dalam cara apapun berhubungan dengan Situs
        dan Syarat &amp; Ketentuan ini akan diselesaikan secara
        eksklusif dalam yurisdiksi pengadilan Republik
        Indonesia.&nbsp;Perjanjian ini akan diatur oleh dan
        ditafsirkan sesuai dengan hukum Republik Indonesia, tanpa
        memperhatikan pertentangan aturan hukum. Customer setuju bahwa
        tindakan hukum apapun atau sengketa yang mungkin timbul dari,
        berhubungan dengan, atau berada dalam cara apapun berhubungan
        dengan situs dan Perjanjian ini akan diselesaikan secara
        eksklusif dalam yurisdiksi pengadilan Republik Indonesia.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>
          <strong>O</strong>
        </strong>
        <strong>
          <strong>. PENGAKHIRAN</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol>
        <li style="margin-left: 20px; margin-right: 80px;">
          Customer dapat memilih untuk berhenti menggunakan Situs
          setiap saat dengan cara menghapus akun dan secara permanen
          menghapus Situs dari perangkat Customer, sehingga
          menonaktifkan penggunaan Situs tersebut. Ketentuan
          Penggunaan Situs secara otomatis berakhir ketika Customer
          secara permanen menghapus akun dalam Situs.
        </li>
        <li style="margin-left: 20px; margin-right: 80px;">
          Sukanda Onelink berhak untuk segera menangguhkan, membatasi atau
          menghentikan akses Customer ke Situs jika Sukanda Onelink memiliki
          alasan untuk mencurigai bahwa Customer telah melanggar
          ketentuan dari Syarat &amp; Ketentuan ini dan peraturan
          perundang-undangan yang berlaku.
        </li>
      </ol>
      <p>
        <strong>
          <strong>P</strong>
        </strong>
        <strong>
          <strong>. PEMBAHARUAN</strong>
        </strong>
      </p>
      <p>&nbsp;</p>
      <p style="margin-left: 20px; margin-right: 80px;">
        Syarat &amp; ketentuan mungkin di ubah dan diperbaharui
        dari waktu ke waktu tanpa pemberitahuan sebelumnya. Sukanda Onelink
        menyarankan agar anda membaca secara seksama dan memeriksa
        halaman Syarat &amp; ketentuan ini dari waktu ke waktu untuk
        mengetahui perubahan apapun. Dengan tetap mengakses dan
        menggunakan layanan Sukanda Onelink, maka Customer dianggap
        menyetujui perubahan-perubahan dalam Syarat &amp; ketentuan.
      </p>
    </div>

</div> 
</section>